import { MoneyString } from 'model/Money'
import {
  AssemblyHeaderRow,
  BoMItemType,
  PartTypeRow,
} from 'model/Project/BoMItemRow'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useAppSelector } from 'store/configureStore'
import { FinancialDto } from 'services/APIs/InternalAPI/internal-api.contracts'
import { RootAppState } from 'store/configureStore'
import { RowThumbnailButton } from '../../../BillOfMaterials/components/BomItemThumbnailButton'
import { TargetPriceTooltipListItemText } from './TargetPriceTooltipListItemText'

export const PartOrAssemblyTooltip = (props: { bomItemId: string }) => {
  const { t } = useTranslation()

  const row: AssemblyHeaderRow | PartTypeRow = useAppSelector(
    (state: RootAppState) =>
      (state.project.flatView[props.bomItemId] ||
        state.project.treeView[props.bomItemId]) as
        | AssemblyHeaderRow
        | PartTypeRow
  )

  let thumbnailPath = ''
  let financial: FinancialDto = undefined
  let name = ''

  switch (row?.type) {
    case 'AssemblyHeader': {
      thumbnailPath = !row.assembly.hasGeometry && row.assembly.thumbnail3d
      financial = row.assembly.financial
      name = row.assembly.name
      break
    }
    case 'Row': {
      thumbnailPath = row.thumbnail3d
      financial = row.financial
      name = row.name
      break
    }
  }

  return (
    <>
      {thumbnailPath && (
        <RowThumbnailButton
          bomItemType={BoMItemType.row}
          showTooltip
          size="small"
          rowId={row.id}
          disableClick
        />
      )}
      <TargetPriceTooltipListItemText
        primary={name}
        secondary={`${t('project:sales-price')}: ${MoneyString(
          financial?.salesPriceOfItems
        )}`}
      />
    </>
  )
}
